var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/upload_form.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import classNames from 'classnames';
import React from 'react';
import { useAppSelector } from 'soapbox/hooks';
import SensitiveButton from '../components/sensitive-button';
import UploadProgress from '../components/upload-progress';
import UploadContainer from '../containers/upload_container';
const UploadForm = () => {
  const mediaIds = useAppSelector(state => state.compose.media_attachments.map(item => item.id));
  const classes = classNames('compose-form__uploads-wrapper', {
    'contains-media': mediaIds.size !== 0
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "compose-form__upload-wrapper",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(UploadProgress, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }, mediaIds.map(id => /*#__PURE__*/React.createElement(UploadContainer, {
    id: id,
    key: id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 11
    }
  }))), !mediaIds.isEmpty() && /*#__PURE__*/React.createElement(SensitiveButton, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 31
    }
  }));
};
export default UploadForm;